<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-primary bg-soft">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Acesso Negado</h5>
                  <p>Você não tem permissão para acessar esta página.</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img src="@/assets/images/error-img.png" alt="" class="img-fluid">
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div class="auth-logo">
              <div class="avatar-md profile-user-wid mb-4">
                <span class="avatar-title rounded-circle bg-light">
                  <i class="bx bx-lock-alt text-primary h2 mb-0"></i>
                </span>
              </div>
            </div>
            <div class="p-2">
              <div class="text-center">
                <div class="avatar-md mx-auto">
                  <div class="avatar-title rounded-circle bg-light">
                    <i class="bx bx-error text-danger h1 mb-0"></i>
                  </div>
                </div>
                <div class="p-2 mt-4">
                  <h4>Acesso Negado!</h4>
                  <p class="mb-0">
                    Você não possui permissão para acessar esta página. 
                    Entre em contato com o administrador do sistema se acredita que isso é um erro.
                  </p>
                  <div class="mt-4">
                    <button class="btn btn-primary w-100" @click="goHome">
                      <i class="bx bx-home me-1"></i>
                      Voltar ao Início
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-5 text-center">
          <p>
            © {{ new Date().getFullYear() }} RadioConnect. 
            Desenvolvido com 
            <i class="mdi mdi-heart text-danger"></i> 
            para radiologia.
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";

export default {
  page: {
    title: "Acesso Negado",
    meta: [{ name: "description", content: "Página de acesso negado" }],
  },
  components: {
    Layout,
  },
  methods: {
    goHome() {
      this.$router.push('/');
    },
  },
};
</script>
